import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1f4d888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "detail-order-statusbox" }
const _hoisted_3 = { class: "detail-order-status" }
const _hoisted_4 = { class: "detail-order-desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reserve-title" }, "备用机服务", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgba(0, 0, 0, 0.44)","font-size":"14px"} }, "查看规则", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reserve-title device-title" }, "备用机信息", -1))
const _hoisted_10 = { class: "detail-net-message" }
const _hoisted_11 = { class: "detail-repair-device" }
const _hoisted_12 = { class: "detail-repair-desc" }
const _hoisted_13 = { class: "repair-desc-first" }
const _hoisted_14 = {
  key: 0,
  class: "repair-desc-second"
}
const _hoisted_15 = { class: "repair-desc-second" }
const _hoisted_16 = { class: "reserve-username" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reserve-username-title" }, "使用人账号", -1))
const _hoisted_18 = { class: "reserve-username-value" }
const _hoisted_19 = {
  key: 0,
  class: "appeal-box error-log"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务历史", -1))
const _hoisted_21 = {
  key: 1,
  class: "appeal-box error-log"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "购买记录", -1))
const _hoisted_23 = {
  key: 0,
  class: "confirm-fixed"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-use-confirmtitle" }, "确认使用后不可取消，请谨慎操作。", -1))
const _hoisted_25 = { class: "agree-text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我已经仔细阅读并同意", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "reserve-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, {
        title: "备用机单",
        isReturnLeftEvent: true,
        onLeftClick: _ctx.handleClikBack
      }, null, 8, ["onLeftClick"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.reserveMesaage.status_text), 1),
          _createElementVNode("div", _hoisted_4, "备用机单号：" + _toDisplayString(_ctx.reserveMesaage.sn), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", {
          class: "appeal-box error-log",
          style: {"margin-top":"8px"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRuleProtoc && _ctx.handleRuleProtoc(...args)))
        }, [
          _createElementVNode("div", {
            class: "appeal-box-title appeal-box-felxtitle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSelectDatePage && _ctx.handleSelectDatePage(...args)))
          }, [
            (_ctx.reserveMesaage.service_type_text == '保内')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "保内-维修期间免费使用"))
              : _createCommentVNode("", true),
            (_ctx.reserveMesaage.service_type_text == '保外')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "保外-维修期间付费使用"))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _hoisted_8,
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "16",
                color: "rgba(0,0,0,0.44)"
              })
            ])
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "detail-net-title",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleNetWorkDetail && _ctx.handleNetWorkDetail(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.reserveMesaage.warehouse_name), 1),
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "16",
              color: "rgba(0,0,0,0.44)"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reserveMesaage.reserveList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "detail-repair-image",
                style: _normalizeStyle(item.url ? { 'background-image': `url(${item.url})` } : {})
              }, null, 4),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.product_name), 1),
                (item.product_sn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.product_sn), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, _toDisplayString(item.notice), 1)
              ])
            ]))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.reserveMesaage.client_phone), 1)
        ]),
        (_ctx.reserveMesaage.has_service_history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "appeal-box-title appeal-box-felxtitle",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleServiceHistory && _ctx.handleServiceHistory(...args)))
              }, [
                _hoisted_20,
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "16",
                  color: "rgba(0,0,0,0.44)"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.reserveMesaage.has_purchse_history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", {
                class: "appeal-box-title appeal-box-felxtitle",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleBuyRecord && _ctx.handleBuyRecord(...args)))
              }, [
                _hoisted_22,
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "16",
                  color: "rgba(0,0,0,0.44)"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    (
        [1, 4, 6].indexOf(_ctx.reserveMesaage.status) >= 0 ||
        (_ctx.reserveMesaage.status == 5 && _ctx.reserveMesaage.is_show)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_ctx.reserveMesaage.status == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  class: "repair-cancel-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChangeStatus(8)))
                }, "不使用"),
                _createElementVNode("button", {
                  class: "repair-confirm-btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleOpenUseDialog && _ctx.handleOpenUseDialog(...args)))
                }, "确认使用")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.reserveMesaage.status == 4)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "repair-confirm-btn",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleChangeStatus(5)))
              }, "确认收货"))
            : _createCommentVNode("", true),
          (_ctx.reserveMesaage.status == 5)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.reserveMesaage.is_show)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "repair-confirm-btn",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleBuyPage && _ctx.handleBuyPage(...args)))
                    }, " 购买使用时长 "))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.reserveMesaage.status == 6)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_ctx.reserveMesaage.is_show)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "repair-cancel-btn",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleBuyPage && _ctx.handleBuyPage(...args)))
                    }, " 购买使用时长 "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "repair-confirm-btn",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleChangeStatus(7)))
                }, "确认归还")
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_dialog, {
      class: "show-use-dialog",
      width: "304",
      title: "确认使用？",
      show: _ctx.showUserDialog,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showUserDialog) = $event)),
      "show-cancel-button": "",
      "confirm-button-color": _ctx.checkedAgree ? '#00B359' : 'rgba(0, 0, 0, 0.22)',
      onConfirm: _ctx.handleConfirmClick,
      onCancel: _ctx.handleCancelUse,
      "before-close": _ctx.handleBeforeClose
    }, {
      default: _withCtx(() => [
        _hoisted_24,
        _createVNode(_component_van_radio_group, {
          modelValue: _ctx.checkedAgree,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkedAgree) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_radio, {
              name: "1",
              "checked-color": "#00B359"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", {
                    style: {"color":"#00b359"},
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleProtoc && _ctx.handleProtoc(...args)))
                  }, "《备用产品使用合同》")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "confirm-button-color", "onConfirm", "onCancel", "before-close"])
  ], 4))
}